__webpack_require__.p = "https://bc-cp-fe.sandbox.securitize.io/";